import { IShoppingCartState } from '@/@types'

const state: IShoppingCartState = {
  shoppingCart: [],
  coupon: '',
}

export default state
